export default __webpack_public_path__ + "static/dj-cristagurl-d1f1acd73627d72ac096783c64b185f5.png";